//export
type DocumentUploadEventType = 'PENDING' | 'IN_PROGRESS' | 'DONE';

export interface DocumentUploadEvent {
  type: DocumentUploadEventType;
  value?: any;
  loaded?: any;
  total?: any;
}

export function handleUploadEvent($event: DocumentUploadEvent) {

  if ($event &&Number.isInteger($event.loaded) &&
    Number.isInteger($event.total) && $event.total > 0) {

    const res: any = {
      progress: Math.ceil((100 * $event.loaded) / $event.total)
    };

    let divBy = 1;
    let suffix = ' B';
    if ($event.total > 1024) {
      divBy = 1024;
      suffix = ' KB';
      if ($event.total > 1024 * 1024) {
        divBy = 1024 * 1024;
        suffix = ' MB';
      }
    }
    let text1 = divBy > 1 ? ($event.loaded / divBy).toFixed(1) : $event.loaded;
    let text2 = divBy > 1 ? ($event.total / divBy).toFixed(1) : $event.total;
    res.loaded = text1 + suffix;
    res.total = text2 + suffix;
    return res;
  }
}
